import ListingPageComponent from "../../Components/listingPage/listingPage";
import 'bootstrap/dist/css/bootstrap.min.css';
import ProfileNavbar from "../../Components/ProfileNavbar/ProfileNavbar";

export default function ListingPage() {

  return (
    <>
      <ProfileNavbar/>
      <div style={{backgroundColor:"white", height:"fit-content"}}>
      <ListingPageComponent/>
      </div>
    </>
  );
}
